import React from "react";

const partnersData = [
    { name: "Google Cloud", img: "google_cloud.png" },
    { name: "Squarespace", img: "Squarespace.png" },
    { name: "HP", img: "HP.png" },
    { name: "Dell", img: "Dell.png" },
    { name: "Lenovo", img: "Lenovo.png" },
];

const Partners = () => {
    return (
        <div className="row align-items-center">
            <div className="title">
                <h3>Partners Tecnológicos</h3>
            </div>
            <div className="col-12">
                <div className="row justify-content-center">
                    {partnersData.map((partner, i) => (
                        <div
                            key={i}
                            className="col-12 col-sm-6 col-lg-4 m-15px-tb"
                            data-aos="fade-up"
                            data-aos-duration="1200"
                            data-aos-delay={i * 100}
                        >
                            <div className="feature-box-03 d-flex justify-content-center align-items-center" style={{ minHeight: '150px', padding: '20px' }}>
                                <img
                                    src={`/img/partners/${partner.img}`}
                                    alt={partner.name}
                                    title={partner.name}
                                    style={{ maxWidth: '100%', height: 'auto', maxHeight: '90px' }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Partners;
